import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createReducer } from '@reduxjs/toolkit';
import { openFloatingPhone } from "./actions";
export var floatingPhoneReducer = createReducer({
  isOpen: false
}, _defineProperty({}, openFloatingPhone.type, function (state) {
  state.isOpen = !state.isOpen;
}));